import type {
  ResponseError,
  SolveTicketInput,
  TicketWithComments,
} from '@rtkwlf/rendall';
import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import { useSelectedOrganization } from '@packages/legacy/organization-context';

import { useRendallApi } from '../use-rendall-api';

type SolveTicketMutateFnParams = {
  requestInput: SolveTicketInput;
  ticketId: string;
};

export const useSolveTicket = (
  options: Omit<
    UseMutationOptions<
      TicketWithComments,
      ResponseError,
      SolveTicketMutateFnParams
    >,
    'mutationFn'
  >,
) => {
  const api = useRendallApi();
  const organization = useSelectedOrganization();

  return useMutation({
    mutationFn: ({ requestInput, ticketId }: SolveTicketMutateFnParams) => {
      return api.solveTicket({
        organizationId: organization.id,
        solveTicketInput: requestInput,
        ticketId,
      });
    },
    ...options,
  });
};
